/* Product page v2 (conversion test)
   - "Select a size" before add to bag (size radios start unselected, submit is blocked until chosen)
   - sticky add-to-bag bar on small screens
   - compact color swatch row: scroll the selected swatch into view
   - rating summary link scrolls to the reviews widget */
(function () {
  'use strict';
  if (window.__productV2) return;
  window.__productV2 = true;

  function t(key, fallback) {
    var s = window.productV2Strings || {};
    return s[key] || fallback;
  }

  function setup(info) {
    if (info.__pdp) return;
    info.__pdp = true;
    var sectionId = info.dataset.section;
    var formId = 'product-form-' + sectionId;
    var requireSize = info.dataset.requireSize === 'true';
    var sizeName = (info.dataset.sizeOptionName || 'Size').trim().toLowerCase();

    function getForm() { return document.getElementById(formId); }
    function getMainBtn() {
      return document.getElementById('ProductSubmitButton-' + sectionId) || (getForm() && getForm().querySelector('button[name="add"]'));
    }
    var fieldsets = Array.prototype.slice.call(info.querySelectorAll('variant-radios fieldset.product-form__input--radios, variant-radios fieldset'));
    fieldsets.forEach(function (f) {
      if (f.querySelector('label.variant-swatch, label.color-swatch')) f.classList.add('pdp-color-fieldset');
    });
    var sizeFs = null;
    fieldsets.forEach(function (f) {
      var lg = f.querySelector('legend');
      if (!sizeFs && lg && lg.textContent.trim().toLowerCase().indexOf(sizeName) === 0) sizeFs = f;
    });

    /* compact swatches: keep the selected color in view */
    var colorFs = info.querySelector('.pdp-color-fieldset');
    if (colorFs) {
      var grp = colorFs.querySelector('.product-form__controls-group');
      var act = colorFs.querySelector('input:checked + label');
      if (grp && act && grp.scrollWidth > grp.clientWidth + 4) grp.scrollLeft = Math.max(0, act.offsetLeft - 16);
    }

    /* keep the Add button usable while the theme refreshes the section after a variant change:
       the theme disables it until a ~900 KB section fetch returns, which on slow connections reads as a dead grey button
       (and leaves it dead if that fetch fails). The variant JSON already tells us whether the pick is in stock. */
    var picker = info.querySelector('variant-radios, variant-selects');
    var variantData = null;
    function getVariants() {
      if (variantData) return variantData;
      var s = picker && picker.querySelector('[type="application/json"]');
      try { variantData = s ? JSON.parse(s.textContent) : []; } catch (e) { variantData = []; }
      return variantData;
    }
    function selectedVariant() {
      if (!picker) return null;
      var opts = Array.prototype.map.call(picker.querySelectorAll('fieldset'), function (fs) {
        var c = fs.querySelector('input[type="radio"]:checked');
        return c ? c.value : null;
      });
      if (!opts.length) opts = Array.prototype.map.call(picker.querySelectorAll('select'), function (sel) { return sel.value; });
      var list = getVariants();
      for (var i = 0; i < list.length; i++) {
        var v = list[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function keepButtonLive() {
      var v = selectedVariant();
      var b = getMainBtn();
      if (v && v.available && b && b.hasAttribute('disabled')) b.removeAttribute('disabled');
    }
    if (picker) picker.addEventListener('change', function () { keepButtonLive(); setTimeout(keepButtonLive, 0); });

    /* size selection required */
    var sizeSelected = true;
    var errorEl = null;
    var legendVal = sizeFs ? sizeFs.querySelector('.product-form__group-option-selected') : null;
    if (requireSize && sizeFs && sizeFs.querySelectorAll('input[type="radio"]').length > 1) {
      sizeSelected = false;
      sizeFs.classList.add('pdp-size-unselected');
      if (legendVal) legendVal.textContent = t('select_size', 'Select a size');
      var markSelected = function (ev) {
        var label = ev.target.closest('label');
        var input = ev.target.closest('input[type="radio"]') || (label && document.getElementById(label.getAttribute('for')));
        if (!input || input.classList.contains('disabled')) return;
        sizeSelected = true;
        sizeFs.classList.remove('pdp-size-unselected', 'is-error');
        if (errorEl) errorEl.hidden = true;
        if (legendVal) legendVal.textContent = input.value;
        updateSticky();
      };
      sizeFs.addEventListener('click', markSelected);
      sizeFs.addEventListener('change', markSelected);
      document.addEventListener('submit', function (e) {
        /* note: form.id is shadowed by the <input name="id"> inside the form, so read the attribute */
        var tid = e.target && e.target.getAttribute ? e.target.getAttribute('id') : null;
        if (tid !== formId || sizeSelected) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        showSizeError();
      }, true);
    }
    function showSizeError() {
      if (!sizeFs) return;
      if (!errorEl) {
        errorEl = document.createElement('p');
        errorEl.className = 'pdp-size-error';
        errorEl.setAttribute('role', 'alert');
        errorEl.textContent = t('size_error', 'Please select a size');
        sizeFs.appendChild(errorEl);
      }
      errorEl.hidden = false;
      sizeFs.classList.remove('is-error');
      void sizeFs.offsetWidth;
      sizeFs.classList.add('is-error');
      var top = sizeFs.getBoundingClientRect().top + window.scrollY - 140;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    /* sticky bar: hoist to <body> so it is never trapped inside a section's stacking context */
    var sticky = info.querySelector('[data-pdp-sticky][data-form-id="' + formId + '"]')
      || (info.closest('.shopify-section') || document).querySelector('[data-pdp-sticky][data-form-id="' + formId + '"]')
      || document.querySelector('body > [data-pdp-sticky][data-form-id="' + formId + '"]');
    if (sticky && sticky.parentElement !== document.body) {
      /* a fresh render (theme editor reload) replaces any copy hoisted earlier */
      document.querySelectorAll('body > [data-pdp-sticky][data-form-id="' + formId + '"]').forEach(function (old) { old.remove(); });
      document.body.appendChild(sticky);
    }
    function currentPriceText() {
      var wrap = info.querySelector('.price-wrapper .price') || info.querySelector('.price');
      if (!wrap) return '';
      var el = wrap.classList.contains('price--on-sale') ? wrap.querySelector('.price__sale .price-item--sale') : wrap.querySelector('.price__regular .price-item--regular');
      return el ? el.textContent.trim() : '';
    }
    function updateSticky() {
      if (!sticky) return;
      var sel = sticky.querySelector('[data-pdp-sticky-selection]');
      if (sel) {
        var parts = [];
        fieldsets.forEach(function (f) {
          var c = f.querySelector('input:checked');
          if (!c) return;
          parts.push(f === sizeFs && !sizeSelected ? t('select_size', 'Select a size') : c.value);
        });
        sel.textContent = parts.join(' · ');
      }
      var p = sticky.querySelector('[data-pdp-sticky-price]');
      var priceText = currentPriceText();
      if (p && priceText) p.textContent = priceText;
      var btn = sticky.querySelector('[data-pdp-sticky-btn]');
      var main = getMainBtn();
      if (btn && main) {
        var soldOut = main.disabled || main.getAttribute('aria-disabled') === 'true';
        btn.disabled = soldOut;
        var lbl = btn.querySelector('.button-label') || btn;
        lbl.textContent = soldOut ? main.textContent.trim() : t('add', 'Add to Bag');
      }
    }
    if (sticky) {
      var btn = sticky.querySelector('[data-pdp-sticky-btn]');
      if (btn) btn.addEventListener('click', function () {
        if (!sizeSelected) { showSizeError(); return; }
        var main = getMainBtn();
        if (main && !main.disabled) main.click();
      });
      var main = getMainBtn();
      if (main && window.IntersectionObserver) {
        new IntersectionObserver(function (entries) {
          var en = entries[0];
          var show = !en.isIntersecting;
          sticky.classList.toggle('is-visible', show);
          document.body.classList.toggle('pdp-sticky-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        }, { threshold: 0 }).observe(main);
      }
      info.addEventListener('change', function () { setTimeout(updateSticky, 50); setTimeout(updateSticky, 700); });
      var priceWrap = info.querySelector('.price-wrapper');
      if (priceWrap && window.MutationObserver) new MutationObserver(function () { updateSticky(); }).observe(priceWrap, { childList: true, subtree: true, characterData: true });
      updateSticky();
    }

    /* rating link -> reviews widget */
    info.querySelectorAll('[data-pdp-reviews-link]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.querySelector('#stamped-main-widget, .stamped-main-widget, #reviews, [data-block-handle="reviews"], .shopify-app-block [id^="stamped"]');
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  function init() {
    document.querySelectorAll('.product__info-container[data-pdp-v2]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
